import addHours from "date-fns/fp/addHours";

export function getInOneHour(now = new Date()) {
  return addHours(1)(now);
}
